import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import {
  saveClient
} from '../../actions/client';
import s from './Welcome.css';

class Welcome extends PureComponent {

  componentWillMount() {
    const newClient = {
      id: this.props.testData.id,
      advisorEmail: this.props.testData.advisorEmail,
      firstName: this.props.testData.firstName,
      lastName: this.props.testData.lastName,
      email: this.props.testData.email,
      gender: null,
      birthYear: null,
    };
    this.setState(Object.assign({}, this.state, {
      client: newClient,
    }));
  }

  formChange = (field, value) => {
    const newClient = Object.assign({}, this.state.client);
    newClient[field] = value;
    this.setState(Object.assign({}, this.state, {
      client: newClient,
    }));
  }

  saveClient = (event) => {
    event.preventDefault();
    if(this.state.client.gender && this.state.client.birthYear) {
      this.props.saveClient(this.state.client);
    }
  }

  render() {
    const { testData } = this.props;
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <div className={s.headerRow}></div>
            <div className={s.headerTitle}>
              Welcome {testData.firstName} {testData.lastName} to WisdomTree's Behavioral Finance Tool
            </div>
            <div className={s.title}>
              Before we start, please tell us about yourself
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12">
            <form>
              <div className="form-group">
                <label htmlFor="gender" className={s.formLabel}>What is your gender:</label>
                <div id="gender" className={s.gender}>
                  <label className="radio-inline">
                    <input
                      onChange={(event) => this.formChange('gender', event.target.value)}
                      className={s.formRadio + ' ' + s.formRadioFirst}
                      type="radio"
                      name="gender"
                      id="gender1"
                      value="female"
                    />Female
                  </label>
                  <label className="radio-inline">
                    <input
                      onChange={(event) => this.formChange('gender', event.target.value)}
                      className={s.formRadio}
                      type="radio"
                      name="gender"
                      id="gender2"
                      value="male"
                    />Male
                  </label>
                  <label className="radio-inline">
                    <input
                      onChange={(event) => this.formChange('gender', event.target.value)}
                      className={s.formRadio}
                      type="radio"
                      name="gender"
                      id="gender3"
                      value="na"
                    />Prefer Not to Say
                  </label>
                </div>
              </div>
              <div className="form-group" style={{marginTop:'30px'}}>
                <div className="col-sm-3" style={{paddingLeft:'0px'}}>
                  <label htmlFor="birthyear" className={s.formLabel}>What is your year of birth:</label>
                  <input
                    style={{width:'100px'}}
                    onChange={(event) => this.formChange('birthYear', event.target.value)}
                    type="text"
                    className={'form-control ' + s.formFieldText}
                    id="birthyear"
                  />
                </div>
              </div>
            </form>
          </div>
        </div>
        <div className="row">
          <div className="col-md-12" style={{textAlign:'center'}}>
            <button onClick={this.saveClient} className={s.saveButton}>LET'S GO</button>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    testData: state.clientData.testData,
  };
}

export default connect(mapStateToProps, {
  saveClient,
})(Welcome);



// WEBPACK FOOTER //
// ./src/components/ClientMode/Welcome.js